import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FilterAwardUnits } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { Button } from 'components/misc'
import { awardUnits as awardUnitsLayout } from 'constants/layout'
import { apiOrganizations } from 'helpers/decorators/api'

// defaultLimit: 5
@apiOrganizations({
  list: true,
  filter: 'userOrgParent'
})
class AwardUnitSelector extends Component {
  static propTypes = {
    activeOrganization: PropTypes.object.isRequired,
    organizations: PropTypes.object.isRequired,
    setOrganizationsParams: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    moveLeader: PropTypes.func.isRequired
  }

  state = {
    activeId: null
  }

  handleSelect = activeId => this.setState({ activeId })

  render() {
    const {
      organizations: { loading, list, offset, limit, pages, sort },
      setOrganizationsParams,
      activeOrganization
    } = this.props
    const { activeId } = this.state

    return (
      <div>
        <FilterAwardUnits
          activeOrganization={activeOrganization}
        />
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={awardUnitsLayout.tableHeadersSimple}
          setParams={setOrganizationsParams}
          selectable
        >
          <Data>
            {list.map(item => (
              <tr
                key={item.id}
                onClick={() => this.handleSelect(item.id)}
                className={activeId === item.id ? 'active' : ''}
              >
                <td>{item.id}</td>
                <td>{get(item, 'name')}</td>
                <td>{get(item, 'organizationType.translationText')}</td>
                <td>{get(item, 'region.name')}</td>
              </tr>
            ))}
          </Data>
        </Table>
        <div className="base-margin--top">
          <div className="row">
            <div className="col-xs-6">
              <Button
                intlKey="button.cancel"
                secondary
                onClick={() => this.props.modal(null)}
              >
                Cancel
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                intlKey="button.change"
                disabled={!activeId}
                onClick={() => this.props.moveLeader(activeId)}
              >
                Change
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AwardUnitSelector
